var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { LitElement } from 'lit';
import { html } from 'lit-html';
import { property, query, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { isNil, uniqueId } from 'lodash-es';
import '../../../input/time/sds-input-time.lit';
import { appendStylesToTheStyleRoot } from '../../../utilities/dom';
import { hideMenuProvider } from '../../../utilities/picker.tools';
import { translate } from '../../../utilities/translate';
import { DayPeriod } from '../../enums/day-period.enum';
import { hourOrMinuteToString, isValidHour, isValidMinute } from '../../utils/time.util';
import '../shared/sds-time-picker-content.lit';
import styles from './sds-time-picker.lit.scss';
import { sdsCustomElement } from '../../../utilities/custom-components';
let SdsTimePicker = (() => {
    var _SdsTimePicker_placeholder_accessor_storage, _SdsTimePicker_format_accessor_storage, _SdsTimePicker_hour_accessor_storage, _SdsTimePicker_minute_accessor_storage, _SdsTimePicker_hint_accessor_storage, _SdsTimePicker_disabled_accessor_storage, _SdsTimePicker_invalid_accessor_storage, _SdsTimePicker_errorMessage_accessor_storage, _SdsTimePicker__inputTime_accessor_storage, _SdsTimePicker__contextMenu_accessor_storage, _SdsTimePicker__hour_accessor_storage, _SdsTimePicker__minute_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-time-picker')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _placeholder_decorators;
    let _placeholder_initializers = [];
    let _placeholder_extraInitializers = [];
    let _format_decorators;
    let _format_initializers = [];
    let _format_extraInitializers = [];
    let _hour_decorators;
    let _hour_initializers = [];
    let _hour_extraInitializers = [];
    let _minute_decorators;
    let _minute_initializers = [];
    let _minute_extraInitializers = [];
    let _hint_decorators;
    let _hint_initializers = [];
    let _hint_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    let __inputTime_decorators;
    let __inputTime_initializers = [];
    let __inputTime_extraInitializers = [];
    let __contextMenu_decorators;
    let __contextMenu_initializers = [];
    let __contextMenu_extraInitializers = [];
    let __hour_decorators;
    let __hour_initializers = [];
    let __hour_extraInitializers = [];
    let __minute_decorators;
    let __minute_initializers = [];
    let __minute_extraInitializers = [];
    var SdsTimePicker = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsTimePicker_placeholder_accessor_storage.set(this, __runInitializers(this, _placeholder_initializers, 'sds.time_picker.placeholder'));
            _SdsTimePicker_format_accessor_storage.set(this, (__runInitializers(this, _placeholder_extraInitializers), __runInitializers(this, _format_initializers, 24)));
            _SdsTimePicker_hour_accessor_storage.set(this, (__runInitializers(this, _format_extraInitializers), __runInitializers(this, _hour_initializers, void 0)));
            _SdsTimePicker_minute_accessor_storage.set(this, (__runInitializers(this, _hour_extraInitializers), __runInitializers(this, _minute_initializers, void 0)));
            _SdsTimePicker_hint_accessor_storage.set(this, (__runInitializers(this, _minute_extraInitializers), __runInitializers(this, _hint_initializers, '')));
            _SdsTimePicker_disabled_accessor_storage.set(this, (__runInitializers(this, _hint_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsTimePicker_invalid_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
            _SdsTimePicker_errorMessage_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
            this.handleChange = (__runInitializers(this, _errorMessage_extraInitializers), () => {
                this.hour = this._hour;
                this.minute = this._minute;
                this.updateValue();
                this.dispatch(this.getDetail());
                this.hideMenu();
            });
            _SdsTimePicker__inputTime_accessor_storage.set(this, __runInitializers(this, __inputTime_initializers, void 0));
            _SdsTimePicker__contextMenu_accessor_storage.set(this, (__runInitializers(this, __inputTime_extraInitializers), __runInitializers(this, __contextMenu_initializers, void 0)));
            _SdsTimePicker__hour_accessor_storage.set(this, (__runInitializers(this, __contextMenu_extraInitializers), __runInitializers(this, __hour_initializers, void 0)));
            _SdsTimePicker__minute_accessor_storage.set(this, (__runInitializers(this, __hour_extraInitializers), __runInitializers(this, __minute_initializers, void 0)));
            this._inputId = (__runInitializers(this, __minute_extraInitializers), uniqueId('sds-time-picker'));
            this.handleInputChange = (event) => {
                if (event.detail.value) {
                    this.initValues(event.detail.value.hour, event.detail.value.minute);
                }
            };
            this.hideMenu = hideMenuProvider(this);
            this.now = () => {
                const date = new Date();
                this._hour = date.getHours();
                this._minute = date.getMinutes();
                this.handleChange();
            };
            this.clear = () => {
                this.hour = undefined;
                this.minute = undefined;
                this._hour = undefined;
                this._minute = undefined;
                this.dispatch(null);
                this.hideMenu();
            };
            this.showContextMenu = () => {
                var _a;
                if (!this._contextMenu.opened) {
                    this._inputTime.focused = true;
                    const trigger = this._inputTime.getInput();
                    (_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.show(trigger);
                    this.initValues(this.hour, this.minute);
                    document.addEventListener('mousedown', this.hideMenu);
                }
            };
        }
        get placeholder() { return __classPrivateFieldGet(this, _SdsTimePicker_placeholder_accessor_storage, "f"); }
        set placeholder(value) { __classPrivateFieldSet(this, _SdsTimePicker_placeholder_accessor_storage, value, "f"); }
        get format() { return __classPrivateFieldGet(this, _SdsTimePicker_format_accessor_storage, "f"); }
        set format(value) { __classPrivateFieldSet(this, _SdsTimePicker_format_accessor_storage, value, "f"); }
        get hour() { return __classPrivateFieldGet(this, _SdsTimePicker_hour_accessor_storage, "f"); }
        set hour(value) { __classPrivateFieldSet(this, _SdsTimePicker_hour_accessor_storage, value, "f"); }
        get minute() { return __classPrivateFieldGet(this, _SdsTimePicker_minute_accessor_storage, "f"); }
        set minute(value) { __classPrivateFieldSet(this, _SdsTimePicker_minute_accessor_storage, value, "f"); }
        /**
         * Hint for this date time picker.
         * @attr
         */
        get hint() { return __classPrivateFieldGet(this, _SdsTimePicker_hint_accessor_storage, "f"); }
        set hint(value) { __classPrivateFieldSet(this, _SdsTimePicker_hint_accessor_storage, value, "f"); }
        /**
         * True if this date time picker is disabled.
         * @attr
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsTimePicker_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsTimePicker_disabled_accessor_storage, value, "f"); }
        /**
         * True if this date time picker is invalid.
         * @attr
         */
        get invalid() { return __classPrivateFieldGet(this, _SdsTimePicker_invalid_accessor_storage, "f"); }
        set invalid(value) { __classPrivateFieldSet(this, _SdsTimePicker_invalid_accessor_storage, value, "f"); }
        /**
         * The error message of this date time picker, in case there is a validation error.
         * @attr
         */
        get errorMessage() { return __classPrivateFieldGet(this, _SdsTimePicker_errorMessage_accessor_storage, "f"); }
        set errorMessage(value) { __classPrivateFieldSet(this, _SdsTimePicker_errorMessage_accessor_storage, value, "f"); }
        get _inputTime() { return __classPrivateFieldGet(this, _SdsTimePicker__inputTime_accessor_storage, "f"); }
        set _inputTime(value) { __classPrivateFieldSet(this, _SdsTimePicker__inputTime_accessor_storage, value, "f"); }
        get _contextMenu() { return __classPrivateFieldGet(this, _SdsTimePicker__contextMenu_accessor_storage, "f"); }
        set _contextMenu(value) { __classPrivateFieldSet(this, _SdsTimePicker__contextMenu_accessor_storage, value, "f"); }
        get _hour() { return __classPrivateFieldGet(this, _SdsTimePicker__hour_accessor_storage, "f"); }
        set _hour(value) { __classPrivateFieldSet(this, _SdsTimePicker__hour_accessor_storage, value, "f"); }
        get _minute() { return __classPrivateFieldGet(this, _SdsTimePicker__minute_accessor_storage, "f"); }
        set _minute(value) { __classPrivateFieldSet(this, _SdsTimePicker__minute_accessor_storage, value, "f"); }
        attributeChangedCallback(name, _old, value) {
            super.attributeChangedCallback(name, _old, value);
            this.validateAndCalculate();
            this.initValues(this.hour, this.minute);
        }
        connectedCallback() {
            super.connectedCallback();
            appendStylesToTheStyleRoot(this, 'sds-time-picker', styles.cssText);
            this.validateAndCalculate();
            this.initValues(this.hour, this.minute);
        }
        render() {
            return html `
            <sds-input-time
                id="${this._inputId}"
                placeholder="${translate(this.placeholder)}"
                value="${this.getTimePickerValue()}"
                readonly="${true}"
                ?disabled="${this.disabled}"
                hint="${this.hint}"
                error-message="${this.errorMessage}"
                ?invalid="${this.invalid}"
                @click="${this.showContextMenu}"
                @sds.input.changed="${this.clear}"
            ></sds-input-time>
            <sds-context-menu>
                <div class="${this.getClasses()}">
                    <sds-time-picker-content
                        hour="${this._hour}"
                        minute="${this._minute}"
                        format="${this.format}"
                        @sds.date-time-content.changed="${this.handleInputChange}"
                    >
                    </sds-time-picker-content>
                    <div class="sds-time-picker__footer">
                        <sds-button
                            label="${translate('sds.button.now')}"
                            type="tertiary"
                            size="sm"
                            @click="${this.now}"
                        ></sds-button>
                        <sds-button
                            label="${translate('sds.button.ok')}"
                            type="primary"
                            size="sm"
                            @click="${this.handleChange}"
                        ></sds-button>
                    </div>
                </div>
            </sds-context-menu>
        `;
        }
        getClasses() {
            return classMap({
                'sds-time-picker': true,
                'sds-time-picker--sm': this.format !== 12,
            });
        }
        disconnectedCallback() {
            document.removeEventListener('mousedown', this.hideMenu);
            this.hideMenu();
            super.disconnectedCallback();
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        validateAndCalculate() {
            if (!isValidHour(this.hour)) {
                console.warn(`'hour' attribute is incorrect.`);
                this.hour = undefined;
                this.minute = undefined;
            }
            if (!isValidMinute(this.minute)) {
                console.warn(`'minute' attribute is incorrect.`);
                this.hour = undefined;
                this.minute = undefined;
            }
        }
        updateValue() {
            this._inputTime.value = this.getTimePickerValue();
        }
        initValues(hour, minute) {
            if (typeof hour === 'number') {
                this._hour = hour;
                this._minute = minute || 0;
            }
            else {
                const date = new Date();
                this._hour = date.getHours();
                this._minute = minute !== null && minute !== void 0 ? minute : date.getMinutes();
            }
        }
        getDetail() {
            if (!isNil(this.hour) && !isNil(this.minute)) {
                return {
                    hour: this.hour,
                    minute: this.minute,
                };
            }
            return null;
        }
        dispatch(value) {
            this.dispatchEvent(new CustomEvent(SdsTimePicker.CHANGE_EVENT, {
                detail: { value },
                bubbles: false,
                composed: false,
            }));
        }
        getTimePickerValue() {
            if (!isNil(this.hour) && this.hour > -1 && !isNil(this.minute) && this.minute > -1) {
                return `${hourOrMinuteToString(this.format === 12
                    ? this.hour === 12 || this.hour === 0
                        ? 12
                        : this.hour % 12
                    : this.hour)}:${hourOrMinuteToString(this.minute)} ${this.format === 12 ? (12 - this.hour > 0 ? DayPeriod.ANTE : DayPeriod.POST) : ''}`;
            }
            return '';
        }
    };
    _SdsTimePicker_placeholder_accessor_storage = new WeakMap();
    _SdsTimePicker_format_accessor_storage = new WeakMap();
    _SdsTimePicker_hour_accessor_storage = new WeakMap();
    _SdsTimePicker_minute_accessor_storage = new WeakMap();
    _SdsTimePicker_hint_accessor_storage = new WeakMap();
    _SdsTimePicker_disabled_accessor_storage = new WeakMap();
    _SdsTimePicker_invalid_accessor_storage = new WeakMap();
    _SdsTimePicker_errorMessage_accessor_storage = new WeakMap();
    _SdsTimePicker__inputTime_accessor_storage = new WeakMap();
    _SdsTimePicker__contextMenu_accessor_storage = new WeakMap();
    _SdsTimePicker__hour_accessor_storage = new WeakMap();
    _SdsTimePicker__minute_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsTimePicker");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _placeholder_decorators = [property({ type: String })];
        _format_decorators = [property({ type: Number })];
        _hour_decorators = [property({ type: Number, reflect: true })];
        _minute_decorators = [property({ type: Number, reflect: true })];
        _hint_decorators = [property({ type: String })];
        _disabled_decorators = [property({ type: Boolean })];
        _invalid_decorators = [property({ type: Boolean })];
        _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
        __inputTime_decorators = [query('sds-input-time')];
        __contextMenu_decorators = [query('sds-context-menu')];
        __hour_decorators = [state()];
        __minute_decorators = [state()];
        __esDecorate(_classThis, null, _placeholder_decorators, { kind: "accessor", name: "placeholder", static: false, private: false, access: { has: obj => "placeholder" in obj, get: obj => obj.placeholder, set: (obj, value) => { obj.placeholder = value; } }, metadata: _metadata }, _placeholder_initializers, _placeholder_extraInitializers);
        __esDecorate(_classThis, null, _format_decorators, { kind: "accessor", name: "format", static: false, private: false, access: { has: obj => "format" in obj, get: obj => obj.format, set: (obj, value) => { obj.format = value; } }, metadata: _metadata }, _format_initializers, _format_extraInitializers);
        __esDecorate(_classThis, null, _hour_decorators, { kind: "accessor", name: "hour", static: false, private: false, access: { has: obj => "hour" in obj, get: obj => obj.hour, set: (obj, value) => { obj.hour = value; } }, metadata: _metadata }, _hour_initializers, _hour_extraInitializers);
        __esDecorate(_classThis, null, _minute_decorators, { kind: "accessor", name: "minute", static: false, private: false, access: { has: obj => "minute" in obj, get: obj => obj.minute, set: (obj, value) => { obj.minute = value; } }, metadata: _metadata }, _minute_initializers, _minute_extraInitializers);
        __esDecorate(_classThis, null, _hint_decorators, { kind: "accessor", name: "hint", static: false, private: false, access: { has: obj => "hint" in obj, get: obj => obj.hint, set: (obj, value) => { obj.hint = value; } }, metadata: _metadata }, _hint_initializers, _hint_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
        __esDecorate(_classThis, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
        __esDecorate(_classThis, null, __inputTime_decorators, { kind: "accessor", name: "_inputTime", static: false, private: false, access: { has: obj => "_inputTime" in obj, get: obj => obj._inputTime, set: (obj, value) => { obj._inputTime = value; } }, metadata: _metadata }, __inputTime_initializers, __inputTime_extraInitializers);
        __esDecorate(_classThis, null, __contextMenu_decorators, { kind: "accessor", name: "_contextMenu", static: false, private: false, access: { has: obj => "_contextMenu" in obj, get: obj => obj._contextMenu, set: (obj, value) => { obj._contextMenu = value; } }, metadata: _metadata }, __contextMenu_initializers, __contextMenu_extraInitializers);
        __esDecorate(_classThis, null, __hour_decorators, { kind: "accessor", name: "_hour", static: false, private: false, access: { has: obj => "_hour" in obj, get: obj => obj._hour, set: (obj, value) => { obj._hour = value; } }, metadata: _metadata }, __hour_initializers, __hour_extraInitializers);
        __esDecorate(_classThis, null, __minute_decorators, { kind: "accessor", name: "_minute", static: false, private: false, access: { has: obj => "_minute" in obj, get: obj => obj._minute, set: (obj, value) => { obj._minute = value; } }, metadata: _metadata }, __minute_initializers, __minute_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsTimePicker = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.CHANGE_EVENT = 'sds.time-picker.changed';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsTimePicker = _classThis;
})();
export { SdsTimePicker };
